import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Base64 } from 'js-base64';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { UtilService } from 'src/app/service/util.service';
import { ActivatedRoute } from '@angular/router';
declare var $: any;
@Component({
  selector: 'cancel-button',
  templateUrl: './cancel-button.component.html',
  styleUrls: ['./cancel-button.component.less']
})
export class CancelButtonComponent implements OnInit {
  @ViewChild('modalSession1') content: any;
  /**
   * variables declaration 
   */
  currentLang: string;
  issessionExpired;
  isIos: boolean;
  flowType: any;
  constructor(private util: UtilService, private modalService: NgbModal, public dialog: MatDialog, private _activatedRoute: ActivatedRoute,
  ) { }
  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      this.flowType = this.util.getFlowType(params);
    });

    this.isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (sessionStorage.getItem("sessioncnc")) {
      if (sessionStorage.getItem("sessioncnc") == "true") {
        document.getElementById("uniqCncBtn").focus();
        $("#uniqCncBtn").focus();
      }
    }
  }

  /**
   * open cancel button modal
   * created by shubham chaudhari
   * 
   * @param content as html conntent 
   */
  openWindowCustomClass(content) {
    this.util.CLOSE_WINDOW_POPUP.next(false);
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', backdrop: 'static', windowClass: 'cancel-modal' }).result.then((result) => {
    }, (reason) => {
    });
  }

  /**
   * Clear session data and all open modal
   * created by shubham chaudhari
   * 
   */
  clearSession() {
    this.modalService.dismissAll();
    sessionStorage.clear();
  }

  /**
   * close the modal and set laguage in seession
   * created by shubham chaudhari
   *
   * 
   */
  dismissModal() {
    // start of adobe code
    if (this.flowType?.type == 'S') {
      var digitalData = {
        "events": {
          "siteInteraction": true
        },
        "interaction": {
          "name": "cibc:digital-switch:cancel-application"
        }

      };
    }
    else if (this.flowType?.type == 'P')
      var digitalData = {
        "events": {
          "siteInteraction": true
        },
        "interaction": {
          "name": "cibc:mortgage-prequalification:cancel-application"
        }

      };
    var digitalDataStr = JSON.stringify(digitalData)

    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\"> var digitalData =" + digitalDataStr + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }

    //end of code  
    this.currentLang = sessionStorage.getItem("lang_ref");
    sessionStorage.clear();
    sessionStorage.setItem("lang_ref", this.currentLang);
    sessionStorage.setItem("redTm", Base64.encode(String(new Date())));
    sessionStorage.setItem("currLang", this.currentLang);
   
      if (this.currentLang == "en") {
        window.location.href = environment.api.mortgageHome_en;
      } else {
        window.location.href = environment.api.mortgageHome_fr;
      }
      this.modalService.dismissAll();
  

  }

  /**
   * cancel button different modal close for ios
   * created by shubham chaudhari
   *
   */
  cancelModal() {
    if (this.isIos) {
      $("#exampleModal").modal("hide");
    }
  }
  /**
   * open modal for all devices except ios
   * created by shubham chaudhari
   * 
   */
  openDialog() {
    this.dialog.open(DialogContentExampleDialog, { disableClose: true, panelClass: 'custom-modal' });
  }
}

/**
 * component for dialog contet and styling
 */
@Component({
  selector: 'dialog-content-example-dialog',
  templateUrl: 'dialog-content-example-dialog.html',
})
export class DialogContentExampleDialog {
  /**
   * close cancel button modal
   * created by shubham chaudhari
   * emp id 1288173
   */
  dismissModal() {
    // start of adobe code
    var digitalData = {
      "events": {
        "siteInteraction": true
      },
      "interaction": {
        "name": "cibc:mortgage-prequalification:cancel-application"
      },
      "errors": [{
        "code": null,
        "field": null,
        "type": null,
        "subtype": null
      }
      ]

    };

    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalData + " if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }
    //end of code  
    let currentLang = sessionStorage.getItem("lang_ref");
    sessionStorage.clear();
    sessionStorage.setItem("lang_ref", currentLang);
    sessionStorage.setItem("redTm", Base64.encode(String(new Date())));
    sessionStorage.setItem("currLang", currentLang);

    if (currentLang == "en") {
      window.location.href = environment.api.mortgageHome_en;
    } else {
      window.location.href = environment.api.mortgageHome_fr;
    }




  }

}